import React from 'react';
import UseContext from '../../../hooks/useContext';
import SlideOverAddMission from './data/slideOverAddMission/slideOverAddMission';
import AddCompanyPanel from 'components/companies/AddCompanyPanel';
import CompleteClientPanel, { COMPLETE_CLIENT_PANEL } from 'components/companies/CompleteClientPanel';
import CompanyEditPanel, { EDIT_COMPANY_PANEL } from 'components/companies/CompanyEditPanel';
import SlideOverCompany from './data/slideOverCompany/slideOverCompany';
import SlideOverQualification from './data/slideOverQualification/slideOverQualification';
import SlideOverSchedule from './data/slideOverSchedule/slideOverSchedule';
import SlideOverTempWorker from './data/slideOverTempWorker/SlideOverTempWorker';
import SlideOverMission from './data/slideOverMission/slideOverMission';
import InvoiceDetailPanel from 'components/invoiceDetail/InvoiceDetailPanel';
import { INVOICE_DETAIL_SLIDE_OVER } from 'components/invoiceDetail/useOpenInvoiceDetail';
import AppointmentPanel from 'components/planning/AppointmentPanel';
import RecordFormPanel from 'components/record/forms/RecordFormPanel';
import TaskFormPanel from 'components/tasks/form/TaskFormPanel';
import TaskPanel from 'components/tasks/panel/TaskPanel';
import CreateMenuPanel, { CREATE_MENU_PANEL } from 'components/sidebar/CreateMenuPanel';
import MentionsPanel, { MENTIONS_PANEL } from 'components/home/MentionsPanel';
import ReviewPanel, { REVIEW_PANEL } from 'components/stats/ReviewPanel';
import { APPOINTMENT_PANEL } from 'hooks/useAppointmentPanel';
import { RECORD_FORM_PANEL } from 'hooks/useRecordPanels';
import { TASK_FORM_PANEL, TASK_PANEL } from 'hooks/useTaskPanels';

const dataSlideOver = new Map();
dataSlideOver.set('add_company', <AddCompanyPanel />);
dataSlideOver.set(COMPLETE_CLIENT_PANEL, <CompleteClientPanel />);
dataSlideOver.set(EDIT_COMPANY_PANEL, <CompanyEditPanel />);
dataSlideOver.set('get_company', <SlideOverCompany />);
dataSlideOver.set('get_temp_worker', <SlideOverTempWorker />);
dataSlideOver.set('get_schedule', <SlideOverSchedule />);
dataSlideOver.set('qualification', <SlideOverQualification />);
dataSlideOver.set('add_mission', <SlideOverAddMission />);
dataSlideOver.set('get_mission', <SlideOverMission />);
dataSlideOver.set(INVOICE_DETAIL_SLIDE_OVER, <InvoiceDetailPanel />);
dataSlideOver.set(TASK_PANEL, <TaskPanel />);
dataSlideOver.set(TASK_FORM_PANEL, <TaskFormPanel />);
dataSlideOver.set(RECORD_FORM_PANEL, <RecordFormPanel />);
dataSlideOver.set(APPOINTMENT_PANEL, <AppointmentPanel />);
dataSlideOver.set(CREATE_MENU_PANEL, <CreateMenuPanel />);
dataSlideOver.set(MENTIONS_PANEL, <MentionsPanel />);
dataSlideOver.set(REVIEW_PANEL, <ReviewPanel />);

const DataSlideOver = ({ setShowCV }) => {
  const { slideOverType } = UseContext();
  const Component = dataSlideOver.get(slideOverType);
  
  // Passer setShowCV uniquement au SlideOverTempWorker
  if (slideOverType === 'get_temp_worker' && setShowCV) {
    return React.cloneElement(Component, { setShowCV });
  }
  
  return <>{Component}</>;
};

export default DataSlideOver;
